import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getAllSkillCategories } from "./redux/slices/skillCategorySlice";
import { getAllTeams } from "./redux/slices/teamSlice";
import { getAllSeniorities } from "./redux/slices/senioritySlice";
import { getAllProjects } from "./redux/slices/projectSlice";

import Header from "./components/UI/Header/Header";
import NotFound from "./components/UI/NotFound/NotFound";
import AuthenticatedRoute from "./screens/AuthenticatedRoute";
import UnauthenticatedRoute from "./screens/UnauthenticatedRoute";

import LoginScreen from "./screens/user/LoginScreen/LoginScreen";
import PasswordChangeScreen from "./screens/user/PasswordChangeScreen/PasswordChangeScreen";
import PasswordResetScreen from "./screens/user/PasswordResetScreen/PasswordResetScreen";
import PasswordResetConfirmScreen from "./screens/user/PasswordResetConfirmScreen/PasswordResetConfirmScreen";

import CollaboratorEditScreen from "./screens/collaborator/CollaboratorEditScreen";
import CollaboratorListScreen from "./screens/collaborator/CollaboratorListScreen";
import CollaboratorRegisterScreen from "./screens/collaborator/CollaboratorRegisterScreen";

import ProjectScreen from "./screens//project/ProjectScreen";
import McpKeyScreen from "./screens/mcp/McpKeyScreen";

function App() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userSlice);

  useEffect(() => {
    if (!user) {
      return;
    }

    if (user.is_admin) {
      dispatch(getAllTeams());
      dispatch(getAllSeniorities());
      dispatch(getAllProjects());
    }

    dispatch(getAllSkillCategories());
  }, [dispatch, user]);

  return (
    <BrowserRouter>
      <Routes>
        {/** Admin users */}
        <Route element={<AuthenticatedRoute user={user} isAdminRoute={true} />}>
          <Route path="/collaborators" element={<CollaboratorListScreen />} />
          <Route path="/collaborators/:id" element={<CollaboratorEditScreen />} />
          <Route path="/collaborator/register" element={<CollaboratorRegisterScreen />} />
          <Route path="/projects" element={<ProjectScreen />} />
          <Route path="/mcp-keys" element={<McpKeyScreen />} />
        </Route>

        {/** Not admin users */}
        <Route element={<AuthenticatedRoute user={user} isAdminRoute={false} />}>
          <Route path="/collaborator" element={<CollaboratorEditScreen />} />
        </Route>

        {/** Unauthenticated only */}
        <Route element={<UnauthenticatedRoute user={user} />}>
          <Route path="/" element={<LoginScreen />} />
          <Route path="/password-reset" element={<PasswordResetScreen />} />
          <Route path="/password-reset-confirm/:uid/:token" element={<PasswordResetConfirmScreen />} />
        </Route>

        {/** Others */}
        <Route path="/password-change" element={<PasswordChangeScreen />} />
        <Route
          path="*"
          element={
            user ? (
              <>
                <Header />
                <NotFound />
              </>
            ) : (
              <NotFound />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
